import {
  TableContainer,
  TableHeading,
  TableRow,
  TableRowItem,
  TableRowItemHeader,
  TableRowText,
  TableWrapper
} from './Table.styles'
import { ITableProps } from './Table.types'

/**
 * Table component
 * @param columns - columns to show in the table
 * @param data - data to show in the table
 * @param styles - styles to apply to the table
 */
export function Table<TItem extends { id: string }>({
  columns,
  data,
  styles,
  selectedId
}: ITableProps<TItem>) {
  return (
    <TableWrapper sx={styles}>
      <TableContainer>
        <TableHeading>
          {columns.map((column) => (
            <TableRowItemHeader key={String(column.id)}>
              {column.text}
            </TableRowItemHeader>
          ))}
        </TableHeading>
        {data.map((row) => (
          <TableRow key={row?.id} selected={row?.id === selectedId}>
            {columns.map((column) => (
              <TableRowItem key={String(column.id)}>
                {!!row[column.id] && (
                  <TableRowText type={column.type}>
                    {String(row[column.id])}
                  </TableRowText>
                )}
              </TableRowItem>
            ))}
          </TableRow>
        ))}
      </TableContainer>
    </TableWrapper>
  )
}

export default Table
